"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ButtonCardOpenModal = void 0;
var react_1 = __importDefault(require("react"));
var ButtonCardOpenModal_module_scss_1 = __importDefault(require("./ButtonCardOpenModal.module.scss"));
var ButtonCardOpenModal = function (props) {
    var handler = props.handler, className = props.className, extraClassName = props.extraClassName, textContent = props.textContent;
    return (react_1.default.createElement("button", { className: "".concat(className || ButtonCardOpenModal_module_scss_1.default.button_card_open_modal, " ").concat(extraClassName), type: "button", onClick: handler }, textContent));
};
exports.ButtonCardOpenModal = ButtonCardOpenModal;
